<template>
    <div class="wrapper">
        <label class="toggle">
            <input class="input" type="checkbox" v-model="newValue" :id="name" :disabled="disabled" @change="$emit('change', $event)">
            <span class="slider" :class="disabled ? 'disabled' : ''"></span>
        </label>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'toggle',
    mixins: [
        Default
    ],
    props: ['name', 'value', 'disabled'],
    data() {
        return {
            newValue: false
        };
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/customInput/input";

    .wrapper {
        width: 3em;
    }

    .toggle {
        position: relative;
        display: inline-block;
        height: 1.5em;
        margin: 0;
        vertical-align: middle;

        input {
            display: none;
            &:checked + .slider {
                background-color: $primary-color;
            }
            &:focus + .slider {
                box-shadow: 0 0 1px #52D160;
            }
            $transformAmount: 90%;
            &:checked + .slider:before {
                -webkit-transform: translateX($transformAmount);
                -ms-transform: translateX($transformAmount);
                transform: translateX($transformAmount);
            }
        }

        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 3em;
            background-color: #ccc;
            -webkit-transition: .4s;
            transition: .4s;
            border-radius: 34px;
            &:before {
                position: absolute;
                content: "";
                height: 75%;
                width: 45%;
                left: 10%;
                bottom: 12%;
                background-color: white;
                -webkit-transition: .4s;
                transition: .4s;
                border-radius: 50%;
            }
        }

        .disabled {
            opacity: 40%;
            cursor: default;
        }
    }
</style>
